/**
 * Navigation from the fleet list to a vehicle (`/flotte/:idNpol/:idVeh`,
 * contract §9). The list row travels as router state so the detail header
 * has a title before `WS2_EA_FIC_VEH` answers (or if it fails).
 */

import { extranetPath } from '../../navigation';

/** Router state carried from a fleet row to the vehicle detail. */
export interface VehicleRouteState {
  /** `IMMAT_VEH` of the row. */
  immat: string | null;
  /** `MARQ_MODL_VEH` of the row. */
  marqueModele: string | null;
}

/** Absolute path of a vehicle detail. */
export function vehiclePath(
  tenantSlug: string | undefined,
  idNpol: string | number,
  idVeh: string | number,
): string {
  return extranetPath(tenantSlug, 'flotte', idNpol, idVeh);
}

function stringOrNull(value: unknown): string | null {
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : null;
}

/** Read the router state defensively (deep link / reload ⇒ empty state). */
export function readVehicleRouteState(state: unknown): VehicleRouteState {
  const record = typeof state === 'object' && state !== null ? (state as Record<string, unknown>) : {};
  return {
    immat: stringOrNull(record.immat),
    marqueModele: stringOrNull(record.marqueModele),
  };
}
